import React from 'react';
import intl from "react-intl-universal";
import 'antd/dist/antd.min.css';
import {Upload, Modal, message} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import http from "../../common/Http";
import axios from "axios";


const getBase64 = (file) => {
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
};


class UploadFile extends React.Component{

    constructor(props){
        super(props);

        this.state = {
            previewVisible: false,
            previewImage: '',
            previewTitle: '',
            fileList: [],
            progress: 0,
        };

        this.handlePreview = this.handlePreview.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.uploadImage = this.uploadImage.bind(this);
    }

    async handlePreview (file){
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }

        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
            previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
        });
    }

    handleChange({ fileList: newFileList }){
        console.log('newFileList:',newFileList);
        this.setState({
            fileList: newFileList,
        });
    }


    beforeUpload(file){
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
            message.error('Image must smaller than 5MB!');
        }
        return isLt5M;
    };

    handleCancel(){
        this.setState({
            previewVisible: false,
        });
    }

    async uploadImage(options){
        let that = this;
        const { onSuccess, onError, file, onProgress } = options;

        axios.interceptors.request.use(
            (config) => {
                config.onUploadProgress = function(event){
                    const percent = Math.floor((event.loaded / event.total) * 100);
                    that.setState({
                        progress: percent
                    });
                    if (percent === 100) {
                        setTimeout(() => that.setState({progress: 0}), 1000);
                    }
                    onProgress({ percent: (event.loaded / event.total) * 100 });
                };
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        const reader = new FileReader();
        reader.readAsDataURL(file); // 读取图片文件

        reader.onload = (file) => {
            const params = {
                file: file.target.result, // 把 本地图片的base64编码传给后台，调接口，生成图片的url
                category: "order"
            };

            // 上传图片的base64编码，调接口后，返回 imageId
            http('post','/v1/file/base64',params)
                .then((res) => {
                    onSuccess(res.data.url,file);// res.data.url
                    // console.log('onSuccess',that.state.fileList)
                }).catch(onError);
        };

    };

    render() {
        const {fileList,previewVisible,previewTitle,previewImage} = this.state;

        const uploadButton = (
            <div>
                <PlusOutlined />
                <div
                    style={{
                        marginTop: 8,
                    }}
                >
                    {intl.get('order.pay_upload')}
                </div>
            </div>
        );

        return (
            <div style={{marginTop: "12px"}}>
                <Upload
                    listType="picture-card"
                    accept="image/gif,image/jpeg,image/jpg,image/png,image/svg,image/webp"
                    maxCount={1}
                    multiple={true}
                    fileList={fileList}
                    onChange={this.handleChange}
                    onPreview={this.handlePreview}
                    beforeUpload={this.beforeUpload}
                    customRequest={this.uploadImage}
                >

                    {fileList.length >= 1 ? null : uploadButton}
                </Upload>
                <Modal visible={previewVisible} title={previewTitle} footer={null} onCancel={this.handleCancel}>
                    <img
                        key={previewImage}
                        alt="example"
                        style={{
                            width: '100%',
                        }}
                        src={previewImage}
                    />
                </Modal>
            </div>
        );
    }

}


export default UploadFile;
